class AqCarousel extends HTMLElement {
  #scroller;
  #slides = [];
  #dots = [];
  #observer = null;
  #mq = null;

  connectedCallback() {
    setTimeout(() => this.#init(), 0);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #init() {
    this.#scroller = this.querySelector('[data-scroller]');
    this.#slides = [...this.querySelectorAll('[data-slide]')];
    this.#dots = [...this.querySelectorAll('[data-dot]')];

    if (!this.#scroller || !this.#slides.length) return;

    this.querySelector('[data-dots]')?.addEventListener('click', (e) => {
      const dot = e.target.closest('[data-dot]');
      if (!dot) return;
      this.#slides[this.#dots.indexOf(dot)]?.scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
        block: 'nearest',
      });
    });

    this.#mq = window.matchMedia('(max-width: 1023px)');
    this.#mq.addEventListener('change', () => this.#toggle());
    this.#toggle();
  }

  #toggle() {
    this.#observer?.disconnect();
    if (!this.#mq.matches) return;

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.#activate(this.#slides.indexOf(entry.target));
        }
      },
      { root: this.#scroller, threshold: 0.6 }
    );

    this.#slides.forEach((s) => this.#observer.observe(s));
    this.#activate(0);
  }

  #activate(i) {
    this.#dots.forEach((d, j) => d.setAttribute('aria-selected', `${j === i}`));
  }
}

customElements.define('aq-carousel', AqCarousel);
